import { render, staticRenderFns } from "./PaymentChannel.vue?vue&type=template&id=52ad4c6d&"
import script from "./PaymentChannel.vue?vue&type=script&lang=js&"
export * from "./PaymentChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports